module.exports = __webpack_public_path__ + "img/about2.3adcc0b7.svg";